import * as AudioFormat from "./IAudioFormat";

export enum SupportedBackends {
    indexeddb,
    testDB
};

export enum BackupStates {
    // Indicates that there is (or was some previously unsaved) ongoing live recording session
    Active,

    // Indicates that there is no current ongoing/previously unsaved live recording session
    None,

    // Indicates that there is some unrecoverable live recording session. ClearBackup should be called to free this up before using.
    // (also useful to log telem when this happens)
    Invalid
}

export interface IAudioBackup {
    Initialize(): Promise<void>;
    IsInitializedSuccessfully(): boolean
    Close(): void;
    FetchBackupState(): Promise<BackupStates>;
    ClearBackup(): Promise<void>;

    BackupFormatProperties(props: AudioFormat.IFormatProperties): Promise<void>;
    FetchFormatProperties(): Promise<AudioFormat.IFormatProperties>;

    BackupChunk(chunk: ArrayBuffer): Promise<void>;
    FetchChunks(): Promise<ArrayBuffer[]>;
};